import { Link } from "wouter";
import { SEOHead } from "../components/SEOHead";
import { FooterPixCapture } from "../components/FooterPixCapture";
import { ArrowLeft, Shield } from "lucide-react";

export default function PixCaptureDatenschutz() {
  return (
    <div className="min-h-screen bg-[var(--color-white)] flex flex-col">
      <SEOHead
        title="Datenschutz – pixcapture.app"
        description="Datenschutzerklärung von pixcapture.app"
        path="/datenschutz"
      />

      <header className="border-b border-[var(--color-light-grey)]">
        <div className="max-w-[1200px] mx-auto px-8 py-6">
          <div className="flex items-center gap-4">
            <Link href="/">
              <button className="hover:bg-gray-100 p-2 rounded">
                <ArrowLeft className="h-5 w-5" />
              </button>
            </Link>
            <Shield className="h-6 w-6 text-[var(--color-accent)]" />
            <h1 className="text-[24px] font-medium tracking-[0.05em] text-[var(--color-black)] leading-none">
              Datenschutzerklärung
            </h1>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-[800px] mx-auto px-8 py-16">
          <div className="prose prose-gray max-w-none">
            <p className="text-[var(--color-grey)] mb-8">Stand: November 2024</p>

            <section className="mb-12">
              <h2>1. Datenschutz auf einen Blick</h2>
              <h3>Allgemeine Hinweise</h3>
              <p className="text-[var(--color-grey)]">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten
                passiert, wenn Sie diese Website besuchen.
              </p>
            </section>

            <section className="mb-12">
              <h2>2. Datenerfassung auf dieser Website</h2>
              <h3>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h3>
              <p className="text-[var(--color-grey)]">
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber pixcapture.app.
              </p>
            </section>

            <section className="mb-12">
              <h2>3. Hosting</h2>
              <p className="text-[var(--color-grey)]">
                Diese Website wird bei Cloudflare Pages gehostet. Cloudflare speichert Server-Logfiles mit IP-Adressen.
              </p>
            </section>

            <section className="mb-12">
              <h2>4. Bildverarbeitung</h2>
              <p className="text-[var(--color-grey)]">
                Hochgeladene Bilder werden verschlüsselt übertragen und nach der Bearbeitung automatisch nach 90 Tagen gelöscht.
              </p>
            </section>

            <section className="mb-12">
              <h2>5. Ihre Rechte</h2>
              <p className="text-[var(--color-grey)]">
                Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer Daten.
              </p>
            </section>

            <div className="mt-12 pt-8 border-t border-[var(--color-light-grey)]">
              <p className="text-[var(--color-grey)] text-[14px]">
                Bei Fragen zum Datenschutz kontaktieren Sie uns unter: <a href="mailto:datenschutz@pixcapture.app" className="text-[var(--color-accent)]">datenschutz@pixcapture.app</a>
              </p>
            </div>
          </div>
        </div>
      </main>

      <FooterPixCapture />
    </div>
  );
}
